import { Shark, Utils, View } from "shark-mvc";

import ApplicatorTeam from "../../_shark_models/ApplicatorTeam";

import templateContent from "../../_shark_templates/views/applicator-team-list.html";

import applicatorTeamEditView from "./applicatorTeamEditView";
import applicatorTeamManager from "../managers/applicatorTeamManager";
import mainNavComponent from "../components/mainNavComponent";
import refreshListButtonComponent from "../../components/refreshListButton/refreshListButtonComponent";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class ApplicatorTeamListView extends View {
	constructor () {
		super("applicatorTeamListView");

		this.setTemplate(templateContent);
	}
	
	beforeLoad () {
		this.refreshList();

		this.set({
			__htmlTitle: "Squadre Posatori | IPM HUB"
		});
	}

	createNewItemBtn_clickHandler () {
		const currApplicatorTeam = new ApplicatorTeam({
			status: 1
		});
	
		Shark.set({
			currApplicatorTeam,
			isEditingApplicatorTeam: true,
		});
	
		Shark.openPage(applicatorTeamEditView);
	}

	init () {
		this.addComponents([mainNavComponent, refreshListButtonComponent, waitBoxComponent]);
		
		Shark.set({
			applicatorTeamList: Shark.get("applicatorTeamList") || [],
			__applicatorTeamListRetrieved: false
		});
	}

	refreshList () {
		waitBoxComponent.open();

		applicatorTeamManager.getList()
		.then(() => {
			let applicatorTeamList = Shark.get("applicatorTeamList");

			if (applicatorTeamList) {
				applicatorTeamList.forEach((item, index) => {
					item.__displayIndex = index + 1;
					item.__index = index;
				});

			}

			waitBoxComponent.close();
			Shark.render();
		});
	}

	singleItemBox_clickHandler (event, data) {
		if (event.target.closest(".preventRowClick") !== null) {
			return;
		}
	
		const currApplicatorTeam = Utils.safp(Shark.get("applicatorTeamList"), "guid", data.guid);
	
		if (currApplicatorTeam) {
			Shark.set({
				currApplicatorTeam,
				isEditingApplicatorTeam: false
			});
			Shark.openPage(applicatorTeamEditView);
		}
	}
}

const applicatorTeamListView = new ApplicatorTeamListView();

Shark.registerView(applicatorTeamListView);

export default applicatorTeamListView;
